/**
 * Reports API — the server forces status 'open' and stamps the reporter
 * from the session (the old `reporter` parameter is gone).
 */
import type { DiscrepancyReport, DiscrepancyReportStatus } from "nailor-plus-shared";
import { api } from "@/api/client";

export interface SubmitReportInput {
  body: string;
  context?: {
    code?: string;
    url?: string;
  };
}

export const submitReport = async (input: SubmitReportInput): Promise<void> => {
  await api<{ id: number }>("/api/discrepancy-reports", { body: input });
};

// Admin-only.
export const listReports = async (): Promise<DiscrepancyReport[]> =>
  api<DiscrepancyReport[]>("/api/discrepancy-reports");

export const setReportStatus = async (
  id: number,
  status: DiscrepancyReportStatus,
): Promise<void> => {
  await api<undefined>(`/api/discrepancy-reports/${id}`, { method: "PATCH", body: { status } });
};
